/* Tiny in-app analytics: fires fire-and-forget POSTs to /api/analytics/event.
 * No PII, dedups by (name, props_key) within a session so we don't spam.
 */
import api from '@/lib/api';

const seen = new Set();

export function track(name, props = {}, opts = {}) {
    if (!name) return;
    const key = opts.once ? `${name}:${JSON.stringify(props)}` : null;
    if (key && seen.has(key)) return;
    if (key) seen.add(key);
    // Fire and forget — never block the UI.
    api.post('/analytics/event', { name, props }).catch(() => {});
}
